import { useMemo } from 'react';

import DraggableEnergy from '@/components/game/3d/physics/DraggableEnergy';
import { logg } from '@/util/logg';

const EnergyBuilderCarbonReservoir = ({
	numCarbon,
	initPos = [3.5, 6, 16.75],
	type = 'carbon-reservoir',
}) => {
	if (numCarbon <= 0) {
		logg('no carbonies found');
		return null;
	}

	function randomPos() {
		return Math.floor(Math.random() * 1.5) - 1.5;
	}

	const carbonObjects = useMemo(() => {
		const carbons: any[] = [];
		const heightOffset = 1.5;

		for (let i = 0; i < numCarbon; i++) {
			const energyColor = 'c';
			const color = 'black';
			const homePosition: [number, number, number] = [
				initPos[0] + randomPos(),
				initPos[1] + 5 + i * heightOffset,
				initPos[2] + randomPos(),
			];

			carbons.push({
				id: `$${type}-${energyColor}-${i}`,
				color,
				energyColor,
				type: 'carbon',
				homePosition,
			});
		}

		return carbons;
	}, [numCarbon, initPos, type]);

	const energyDisplay = carbonObjects.map((energyObj) => (
		<DraggableEnergy key={energyObj.id} energy={energyObj} rotato={0} />
	));

	return <group key={`${type}_energy_group`}>{energyDisplay}</group>;
};

export default EnergyBuilderCarbonReservoir;
